import { render, staticRenderFns } from "./OrientationWarning.vue?vue&type=template&id=3bdeec4c&scoped=true&"
import script from "./OrientationWarning.vue?vue&type=script&lang=js&"
export * from "./OrientationWarning.vue?vue&type=script&lang=js&"
import style0 from "./OrientationWarning.vue?vue&type=style&index=0&id=3bdeec4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdeec4c",
  null
  
)

export default component.exports